export default {"src":"https://app.iconosquare.com/_next/static/media/star-icon.133640f2.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};